import React, { forwardRef } from "react";

import cn from "classnames";

import s from "./Text.module.css";

type TextProps = "p" | "span" | "div" | "strong" | "small";

interface IText extends React.HTMLProps<HTMLParagraphElement> {
  children: React.ReactNode;
  className?: string;
  as?: TextProps;
  variant?: "note";
}

// Use forwardRef to pass refs to the underlying DOM element
const Text = forwardRef<HTMLElement, IText>(
  ({ children, as: Tag = "p", className, style, variant, ...rest }, ref) => {
    if (variant === "note") {
      return (
        <span
          className={cn(s.root, "text-xs text-light-gray", className)}
          {...rest}
          style={style}
          ref={ref}
        >
          {children}
        </span>
      );
    }

    return (
      <Tag
        className={cn(s.root, className)}
        {...rest}
        style={style}
        //@ts-ignore
        ref={ref}
      >
        {children}
      </Tag>
    );
  },
);

export default Text;
